import { useEffect, RefObject } from 'react'

import { selectCorrectConsecutiveAnswers } from '~/bootcamp/slices/bootcamp-activity.slice'
import { useAppSelector } from '~/redux/hooks'

export default function useFocus(
  autofocus: boolean,
  answerState: boolean | null,
  inputRef: RefObject<HTMLInputElement>,
  levelId = '', // not always required...
): void {
  const correctConsecutiveAnswers = useAppSelector(selectCorrectConsecutiveAnswers)
  useEffect(() => {
    if (autofocus && inputRef.current) {
      inputRef.current.focus()
      if (correctConsecutiveAnswers === 3) inputRef.current.blur()
    }
  }, [autofocus, answerState, correctConsecutiveAnswers, levelId, inputRef])
}
